import { GetTonePriceDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/gettoneprice/gettonepricedetailsdto';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { APIFeatures } from 'src/com/sixdee/crbtportal/core/util/apifeatures';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { BuyToneAPIModelImpl, BuyToneAPIModel } from '../buytone/buytoneapimodel';
import { MSISDNValidationCSSStyleImpl } from './msisdnvalidationcss';
import { MSISDNValidationViewImpl } from './msisdnvalidationview';

export interface MSISDNValidationComponentProps extends UIComponentProps
{
    headerTitle:string;
    toneDto: ToneDto;
    showPopupOption(id:string):void;
    closePopup(): void;
    showPopup(id:string,msg:string,type:AlertType):void;
}

export interface MSISDNValidationComponentHandler extends UIComponentHandler
{
    onConfirmClick():void;
    onClosePopup():void;
  
}

export interface MSISDNValidationComponentState extends  UIComponentState
{
    msisdn: string;
    isNewUser:boolean;
}

export class MSISDNValidationComponent extends UIComponentImpl<MSISDNValidationComponentProps, MSISDNValidationComponentState, UIDataModel> implements MSISDNValidationComponentHandler
{
    constructor(props: MSISDNValidationComponentProps)
    {
        super(props);

        this.state={msisdn: "",isNewUser:false, };
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new MSISDNValidationViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new MSISDNValidationCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new BuyToneAPIModelImpl(applicationContext, apiModelHandler);
    }
    onConfirmClick():void
    {
        if(this.getView().validate())
        {
            if((this.getView() as MSISDNValidationViewImpl).validate())
            {
              (this.getView() as MSISDNValidationViewImpl).showLoader();  
              (this.getAPIModel() as BuyToneAPIModel).getTonePriceNonLoggedInuser((this.getView() as MSISDNValidationViewImpl).getData());
            } 

        }
    }

    
    onRequestOtpClick()
    {
          (this.getView() as MSISDNValidationViewImpl).showLoader();  
          (this.getAPIModel() as BuyToneAPIModel).getOTP((this.getView() as MSISDNValidationViewImpl).getOTPData());
    }
    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        if(feature === APIFeatures.GET_TONE_PRICE)
        {
            (this.getView() as MSISDNValidationViewImpl).dismissLoader();  
           
             this.setState({msisdn: description, isNewUser:(data as GetTonePriceDetailsDto).getIsNewUser()}, () =>
             {
                 this.onRequestOtpClick();
             });
        }
       else  if(feature === APIFeatures.GENERATE_OTP)
        {
            (this.getView() as MSISDNValidationViewImpl).dismissLoader();  
            this.props.context.getUserContext().setMsisdnB(this.state.msisdn);
            (this.props.context.getUserContext().setSecToken(""));
            this.props.context.getUserContext().setPackName("");
            this.props.context.getUserContext().setIsnewUser(this.state.isNewUser);
            this.props.context.setUserContext(this.props.context.getUserContext());

            this.props.showPopupOption(this.getContext().getResources().getString(Strings.buy_now) + "_" +
                this.props.context.getResources().getString(Strings.upgradePack) + "_" + 
                this.props.context.getResources().getString(Strings.otp_verification));
                console.log("upgrade pack redirection :Buy Now");
        }
        else
        {
            (this.getView() as MSISDNValidationViewImpl).dismissLoader();    
        }
    }
    
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as MSISDNValidationViewImpl).dismissLoader();  
        
        this.props.showPopup(this.getContext().getResources().getString(Strings.buy_now),description,AlertType.ERROR);   

    }  
    onClosePopup():void
    {
        this.props.closePopup();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/msisdnvalidation/msisdnvalidationcomponent.tsx